import { Grid, ListItemButton, Drawer as MuiDrawer } from "@mui/material";
import SettingsArea from "./../../components/custom/PersonalMenu/SettingsArea/index";
import Logo from "../custom/Logo";
import { NavLink } from "react-router-dom";
import React from "react";
import SidebarNav from "./SidebarNav";
import styled from "styled-components/macro";

const Drawer = styled(MuiDrawer)`
  height: 100%;
  & .MuiPaper-root {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    background-color: ${(props) =>
      props.theme.palette.background.menuBackground};
    border-radius: 45px;
    position: static;
  }

  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const GridItem = styled(Grid)`
  width: 100%;
`;

const Brand = styled(ListItemButton)`
  display: flex;
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(1.8)};
  padding-right: ${(props) => props.theme.spacing(1.8)};

  &:hover {
    background-color: inherit;
  }
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }
`;

const Sidebar = ({ items, showFooter = true, ...rest }) => {
  return (
    <Drawer variant="permanent" {...rest}>
      <Grid
        // sx={{ flexGrow: 1, height: "100%", paddingLeft: "2px" }}
        // wrap="nowrap"
        container
        spacing={2}
        direction="column"
        justifyContent="space-between"
      >
        <GridItem item>
          <Brand component={NavLink} to="/" disableRipple>
            <Logo />
          </Brand>
        </GridItem>
        {/* <GridItem item xs={7}>
          <SidebarNav items={items} />
        </GridItem> */}
        <GridItem item>
          <SidebarNav items={items} />
        </GridItem>
        <Grid container justifyContent="center" alignItems="center" pt={40}>
          <Grid>
            <SettingsArea />
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default Sidebar;
